exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onboard-questions__item{opacity:0}.onboard-questions__item.active{opacity:1}.onboard-questions__answer{display:flex;justify-content:space-between}.onboard-questions__answer span{display:table}", ""]);

// exports
